"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */

var id = 1;

exports.default = function () {
  return "" + id++;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../~/size-sensor/lib/id.js
// module id = h4mG
// module chunks = 0